import {
  addChatReaction,
  removeChatReaction,
} from "../../api/ProcurementClient";
import { ChatMessage, ChatReactionEvent } from "../../models/Chat";

export function toggleChatReaction(
  message: ChatMessage,
  emoji: string,
  meId: number
): Promise<ChatMessage> {
  const existing = message.reactions.find((r) => r.emoji === emoji);
  return existing?.userIds.includes(meId)
    ? removeChatReaction(message.id, emoji)
    : addChatReaction(message.id, emoji);
}

export function replaceMessage(list: ChatMessage[], message: ChatMessage): ChatMessage[] {
  const index = list.findIndex((m) => m.id === message.id);
  if (index === -1) return list;
  const next = list.slice();
  next[index] = message;
  return next;
}

export function appendMessage(list: ChatMessage[], message: ChatMessage): ChatMessage[] {
  if (list.some((m) => m.id === message.id)) return replaceMessage(list, message);
  return [...list, message];
}

export function applyReaction(list: ChatMessage[], reaction: ChatReactionEvent): ChatMessage[] {
  const index = list.findIndex((m) => m.id === reaction.messageId);
  if (index === -1) return list;
  const next = list.slice();
  next[index] = { ...next[index], reactions: reaction.reactions };
  return next;
}

const COMPACT_WINDOW_MS = 5 * 60 * 1000;

export function isCompactFollowUp(prev: ChatMessage | undefined, message: ChatMessage): boolean {
  if (!prev || prev.authorId !== message.authorId || prev.deletedAt) return false;
  if (prev.replyCount > 0) return false;
  const gap = new Date(message.createdAt).getTime() - new Date(prev.createdAt).getTime();
  return gap >= 0 && gap < COMPACT_WINDOW_MS;
}
